module.exports = __webpack_public_path__ + "static/media/Artboard23.cc0aeac8.png";